<div class="w-full  rounded-[10px] space-y-[5px] cursor-pointer">

    <button 
      class=" cursor-pointer w-full px-4 py-3 flex items-center justify-between sm:px-4 sm:py-2.5 text-left sm:text-sm text-sm bg-[#F1F9FE]  font-medium rounded-[10px] text-[#101828] border border-[#86CFF3]"
      (click)="isOpen.set(!isOpen())"
    >
    {{accessibility_of_org()}}
    <span class="icon-angle-down"></span>
    </button>
  
  
    <div 
      class="overflow-hidden transition-all duration-700 ease-in-out rounded  " 
      [class.max-h-0]="!isOpen()"
      [class.max-h-[800px]]="isOpen()"
      [class.border-transparent] ="!isOpen()"
    >
      <div class="bg-gray-100 p-3 sm:p-4 text-xs sm:text-sm  rounded border border-[#95CDFF]">
        <p class="mb-2 ">This company has following facilities for person of disabilities</p>
       
        @if (hasInclusionPolicy) {
          <div class="flex gap-1 items-center">
            <img [src]="environment.homeImageUrl + 'Accessibility/btik.svg'" alt="D&I Policy">
            <p class="text-gray-800 py-1">{{ hasInclusionPolicy }}</p>
          </div>
        }
        
        @for (item of filteredItems; track $index) {
          <div class="flex gap-1 items-center">
            <img [src]="item.Logo" alt="{{ item.Name }}.jpg">
            <p class="text-[#333] py-1">{{ item.Name }}</p>
          </div>
        }
        <p class=" text-xs sm:text-sm text-[#5c5c5c] font-normal sm:mt-2 mt-2 text-justify">
          “Accessibility features are self-reported by the employer and we trust the reliability of this information. We unable to verify the employer’s accessibility features statement.
           Please use the report feature in this page if you believe this information is innacurate.”
        </p>
        <div class="my-3">
          <button (click)="scroll.emit()" class="px-4 py-2.5 bg-transparent flex items-center justify-center gap-2 border border-[#92c0e9] text-[#2f80c8] rounded"><span class="icon-angle-up"></span>Back to Top</button>
        </div>
      </div>
    </div>
  </div>
